import { render, staticRenderFns } from "./DetailDependents.vue?vue&type=template&id=94fce710&"
import script from "./DetailDependents.vue?vue&type=script&lang=js&"
export * from "./DetailDependents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports